const routes = [
  {
    path: '/recursos-humanos/funcionario',
    name: 'employee',
    component: () => import('@/views/sistema/recursosHumanos/funcionario/Funcionario.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Funcionários' }] },
  },
  {
    path: '/recursos-humanos/funcionario/novo',
    name: 'employeeNew',
    component: () => import('@/views/sistema/recursosHumanos/funcionario/FuncionarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Funcionários' }, { title: 'Novo' }] },
  },
  {
    path: '/recursos-humanos/funcionario/:id/editar',
    name: 'employeeUpdate',
    component: () => import('@/views/sistema/recursosHumanos/funcionario/FuncionarioNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Funcionários' }, { title: 'Editar' }] },
  },

  {
    path: '/recursos-humanos/equipes',
    name: 'team',
    component: () => import('@/views/sistema/recursosHumanos/equipe/Equipe.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }] },
  },
  {
    path: '/recursos-humanos/equipes/novo',
    name: 'teamNew',
    component: () => import('@/views/sistema/recursosHumanos/equipe/EquipeNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Novo' }] },
  },
  {
    path: '/recursos-humanos/equipes/:id/editar',
    name: 'teamUpdate',
    component: () => import('@/views/sistema/recursosHumanos/equipe/EquipeNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Editar' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/funcionario',
    name: 'employeeTeamChildren',
    component: () => import('@/views/sistema/recursosHumanos/equipe/funcionarioEquipe/FuncionarioEquipePai.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Funcionários' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/funcionario/novo',
    name: 'employeeTeamNew',
    component: () => import('@/views/sistema/recursosHumanos/equipe/funcionarioEquipe/FuncionarioEquipeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Funcionários' }, , { title: 'Novo' }],
    },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/funcionario/:id/editar',
    name: 'employeeTeamUpdate',
    component: () => import('@/views/sistema/recursosHumanos/equipe/funcionarioEquipe/FuncionarioEquipeNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Funcionários' }, { title: 'Editar' }],
    },
  },
  // {
  //   path: '/recursos-humanos/equipe/:idTeam/equipamentosLeve',
  //   name: 'teamEquipment',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/equipamentosLeve/EquipamentosLeve.vue'),
  //   meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Equipamentos Leves' }] },
  // },
  // {
  //   path: '/recursos-humanos/equipe/:idTeam/equipamentosLeve/novo',
  //   name: 'teamEquipmentNew',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/equipamentosLeve/EquipamentosLeveNew.vue'),
  //   meta: {
  //     breadcrumb: [
  //       { title: 'Recursos Humanos' },
  //       { title: 'Equipes' },
  //       { title: 'Equipamentos Leves' },
  //       { title: 'Novo' },
  //     ],
  //   },
  // },
  // {
  //   path: '/recursos-humanos/equipe/:idTeam/equipamentosLeve/:id/editar',
  //   name: 'teamEquipmentUpdate',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/equipamentosLeve/EquipamentosLeveNew.vue'),
  //   meta: {
  //     breadcrumb: [
  //       { title: 'Recursos Humanos' },
  //       { title: 'Equipes' },
  //       { title: 'Equipamentos Leves' },
  //       { title: 'Editar' },
  //     ],
  //   },
  // },
  {
    path: '/recursos-humanos/funcionario/:idEmployee/encargos',
    name: 'employeeCharge',
    component: () => import('@/views/sistema/recursosHumanos/funcionario/encargos/Encargo.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Funcionários' }] },
  },
  {
    path: '/recursos-humanos/funcionario/:idEmployee/encargos/novo',
    name: 'employeeChargeNew',
    component: () => import('@/views/sistema/recursosHumanos/funcionario/encargos/EncargoNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Funcionários' }, { title: 'Novo' }] },
  },
  {
    path: '/recursos-humanos/funcionario/:idEmployee/encargos/:id/editar',
    name: 'employeeChargeUpdate',
    component: () => import('@/views/sistema/recursosHumanos/funcionario/encargos/EncargoNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Funcionários' }, { title: 'Editar' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/metaEquipe',
    name: 'teamPointChildren',
    component: () => import('@/views/sistema/recursosHumanos/equipe/metaEquipe/MetaEquipe.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Meta' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/metaEquipe/novo',
    name: 'teamPointNew',
    component: () => import('@/views/sistema/recursosHumanos/equipe/metaEquipe/MetaEquipeNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Meta' }, { title: 'Novo' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/metaEquipe/:id/editar',
    name: 'teamPointUpdate',
    component: () => import('@/views/sistema/recursosHumanos/equipe/metaEquipe/MetaEquipeNew.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Meta' }, { title: 'Editar' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/despesasBaseEquipe',
    name: 'teamExpense',
    component: () => import('@/views/sistema/recursosHumanos/equipe/despesaBase/DespesaBase.vue'),
    meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Despesa' }] },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/despesasBaseEquipe/novo',
    name: 'teamExpenseNew',
    component: () => import('@/views/sistema/recursosHumanos/equipe/despesaBase/DespesaBaseNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Despesa' }, { title: 'Novo' }],
    },
  },
  {
    path: '/recursos-humanos/equipe/:idTeam/despesasBaseEquipe/:id/editar',
    name: 'teamExpenseUpdate',
    component: () => import('@/views/sistema/recursosHumanos/equipe/despesaBase/DespesaBaseNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Despesa' }, { title: 'Editar' }],
    },
  },
  // {
  //   path: '/recursos-humanos/equipe/:idTeam/multasDeTransito',
  //   name: 'trafficTicket',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/multas/Multas.vue'),
  //   meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Multas de trânsito' }] },
  // },
  // {
  //   path: '/recursos-humanos/equipe/:idTeam/multasDeTransito/novo',
  //   name: 'trafficTicketNew',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/multas/MultasNew.vue'),
  //   meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Multas de trânsito' }] },
  // },
  // {
  //   path: '/recursos-humanos/equipe/:idTeam/multasDeTransito/:id/editar',
  //   name: 'trafficTicketUpdate',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/multas/MultasNew.vue'),
  //   meta: { breadcrumb: [{ title: 'Recursos Humanos' }, { title: 'Equipes' }, { title: 'Multas de trânsito' }] },
  // },
  // {
  //   path: '/sistema/itemEquipe/novo',
  //   name: 'itemEquipeNew',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/cargaItem/CargaItemNew.vue'),
  //   meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Itens por Equipe' }, { title: 'Novo' }] },
  // },
  // {
  //   path: '/sistema/itemEquipe/:id/editar',
  //   name: 'itemEquipeUpdate',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/cargaItem/CargaItemNew.vue'),
  //   meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Itens por Equipe' }, { title: 'Editar' }] },
  // },
  // {
  //   path: '/sistema/itemEquipe',
  //   name: 'teamItemsTotal',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/cargaItem/CargaItem.vue'),
  //   meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Item' }] },
  // },
  // {
  //   path: '/sistema/itemEquipe',
  //   name: 'teamItemsTotal',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/cargaItem/CargaItem.vue'),
  //   meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Itens por Equipe' }] },
  // },
  // {
  //   path: '/sistema/itemEquipe/novo',
  //   name: 'itemEquipeNew',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/cargaItem/CargaItemNew.vue'),
  //   meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Itens por Equipe' }] },
  // },
  // {
  //   path: '/sistema/item-equipe/:id/editar',
  //   name: 'itemEquipeUpdate',
  //   component: () => import('@/views/sistema/recursosHumanos/equipe/cargaItem/CargaItemNew.vue'),
  //   meta: { breadcrumb: [{ title: 'Almoxarifado' }, { title: 'Itens por Equipe' }, { title: 'Editar' }] },
  // },
]

export default routes
